module.exports = __webpack_public_path__ + "static/img/numBg.442eb9cc.svg";